import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { notification, Typography, Upload } from 'antd';
import { PrimaryButtonX } from '../Components/Button3D';
import { useStoreState, useStoreActions } from '../myStore/index';
import UploadImg from '../assets/images/uploadImg.png';
import { useHistory } from 'react-router-dom';
import HeaderComponent from '../Components/HeaderComponents';
import FooterPublic3D from '../Components/FooterPublic3D';

const { Dragger } = Upload;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
`
const DraggerSection = styled(Dragger)`
  display: flex;
  width: 500px !important;
  height: 300px!important;
  background: white !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  @media screen and (max-width: 768px) {
    width: 300px !important;
    height: 300px!important;
  }
`;
const UploadThumbnail: FC = () => {
    const history = useHistory();
    const [files, setFiles] = useState<any>([]);

    const currentItem = useStoreState((state: any) => state.cart.currentItem);
    const setCurrentItem = useStoreActions((actions: any) => actions.cart.setCurrentItem);

    const props = {
        name: "file",
        beforeUpload: async (file: any, fileList: any) => {
            return false;
        },
        onChange(info: any) {
            setFiles(info.fileList);
        },
    };
    const onClick = () => {
        if (files.length === 0) {
            notification.error({
                message: 'Error',
                description: 'please select the Thumbnail Image'
            })
        } else {
            setCurrentItem({ ...currentItem, designThumbnail: files });
            history.push('/design/quantity');
        }
    }
    const onSkipClick = () => {
        history.push('/design/quantity');
    }
    return (
        <>
            <div>
                <HeaderComponent />
                <Container>
                    <div>
                        <Typography.Title level={3} style={{ textAlign: 'center', marginTop: '1rem' }}> Upload your Thumbnail</Typography.Title>
                        <DraggerSection {...props}
                            accept=".png, .jpg, .jpeg"
                            listType='picture'
                        >
                            <div>
                                <Typography>Drag and Drop or</Typography>
                                <img src={UploadImg} alt='' style={{ marginTop: '2rem' }}></img>
                            </div>
                        </DraggerSection>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                            <PrimaryButtonX type='primary' style={{ marginRight: '1rem' }} onClick={onSkipClick}>Skip</PrimaryButtonX>
                            <PrimaryButtonX type='primary' onClick={onClick}>Next</PrimaryButtonX>
                        </div>
                    </div>
                </Container>
                <FooterPublic3D />
            </div>
        </>
    )
}

export default UploadThumbnail;